module.exports = __webpack_public_path__ + "img/img35.824af662.png";